// extracted by mini-css-extract-plugin
export default {"situationTable":"RecordSituationTable_situationTable__xGi2F"};